import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { Tab_Dining_And_Bar } from './Tab_Dining_And_Bar';
import { Tab_Kitchen } from './Tab_Kitchen';

import { Modal_ManageRestaurant } from './Modal_ManageRestaurant';

import '../../../css/layout.css';

export function RestaurantTab (){

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);

    let [tab_DiningAndBar, setTab_DiningAndBar] = useState(true);
    let [tab_Kitchen, setTab_Kitchen] = useState(false);

    let [color_tab_DiningAndBar, setColor_Tab_DiningAndBar] = useState('outline');
    let [color_tab_Kitchen, setColor_Tab_Kitchen] = useState('clear');

    let [manageRestaurantModal, setManageRestaurantModal] = useState(false);


    function tab_diningAndBarHandler()
    {
        setTab_DiningAndBar(true);
        setTab_Kitchen(false);

        setColor_Tab_DiningAndBar('outline');
        setColor_Tab_Kitchen('clear');



    }
    function tab_kitchenHandler()
    {
        setTab_DiningAndBar(false);
        setTab_Kitchen(true);

        setColor_Tab_DiningAndBar('clear');
        setColor_Tab_Kitchen('outline');


    }

        return ( 
            <React.Fragment>
                <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol size = '6'>
                                <IonButton className= 'small-button-tabs' fill={color_tab_DiningAndBar} onClick={() => tab_diningAndBarHandler()}> Dining </IonButton>
                            </IonCol>
                            <IonCol size = '6'>
                                <IonButton className= 'small-button-tabs' fill={color_tab_Kitchen} onClick={() => tab_kitchenHandler()}> Kitchen </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>
               {(authenticatedMerchent_context.accessRights[0] == 'admin' || authenticatedMerchent_context.accessRights[0] == 'manager')  && <IonItem>
                    <IonGrid>
                        <IonRow>
                            <IonCol size='12'>
                                <IonButton onClick={() => setManageRestaurantModal(true)}>MANAGE</IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonItem>}


                {tab_DiningAndBar == true && <Tab_Dining_And_Bar openModal={ tab_DiningAndBar } closeModal={() => setTab_DiningAndBar(false)}></Tab_Dining_And_Bar>}
                {tab_Kitchen == true && <Tab_Kitchen openModal={ tab_Kitchen } closeModal={() => setTab_Kitchen(false)}></Tab_Kitchen>}        

                {manageRestaurantModal == true && <Modal_ManageRestaurant openModal={ manageRestaurantModal } closeModal={() => setManageRestaurantModal(false)}></Modal_ManageRestaurant>}    


            </React.Fragment>
        )
}